import firebase from "firebase/app";
import "./firebaseConfig";
import "firebase/app";
import "firebase/auth";
import constants from "./constants";
import store from "./store";
import router from "./router";
// var database = firebase.database();

export const register = (email, password, name) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        let user = firebase.auth().currentUser;
        let userId = firebase.auth().currentUser.uid;
        user
          .updateProfile({
            displayName: name,
            photoURL: constants.profile.default_user_image
          })
          .then(() => {
            user
              .sendEmailVerification()
              .then(() => {
                saveinDatabase(userId, name, email);
                resolve(user);
              })
              .catch(error => {
                console.log(error);
                resolve(user);
              });
          })
          .catch(error => {
            console.log(error);
            resolve(user);
          });
      })
      .catch(error => {
        console.log(error);
        reject(error.code);
      });
  });
};
export const googleLogin = () => {
  return new Promise((resolve, reject) => {
    // Using a popup.
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(userCredential => {
        resolve(userCredential.user);
      })
      .catch(error => {
        reject(error.code);
      });
    // end popup.

    //using a  redirect
    // firebase
    //   .auth()
    //   .getRedirectResult()
    //   .then((userCredential) => {
    //     resolve(userCredential.user);
    //   })
    //   .catch((error) => {
    //     reject(error.code);
    //   });
    // // Start a sign in process for an unauthenticated user.
    // var provider = new firebase.auth.GoogleAuthProvider();
    // provider.addScope("profile");
    // provider.addScope("email");
    // firebase.auth().signInWithRedirect(provider);
    // end using redirect
  });
};
export const facebookLogin = () => {
  return new Promise((resolve, reject) => {
    // Using a popup.
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(userCredential => {
        resolve(userCredential.user);
      })
      .catch(error => {
        // Handle Errors here.
        // var errorCode = error.code;
        console.log(error);

        // var errorMessage = error.message;
        // The email of the user's account used.
        // var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential;
        // ...
        reject(error.code);
      });
  });
};
export const login = (email, password) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(userCredential => {
        resolve(userCredential.user);
      })
      .catch(error => {
        reject(error.code);
      });
  });
};

export const getUser = () => {
  store.dispatch("clearAuth");
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      store.dispatch({
        type: "updateUser",
        user: user
      });
      if (localStorage.getItem("goBackTo")) {
        const goBackTo = localStorage.getItem("goBackTo");
        localStorage.removeItem("goBackTo");
        router.push(goBackTo);
      }
    } else {
      store.dispatch("clearAuth");
    }
  });
};

export const logout = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const resendVerification = () => {
  return new Promise((resolve, reject) => {
    let user = firebase.auth().currentUser;
    user
      .sendEmailVerification()
      .then(function() {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const sendResetLink = email => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(function() {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const updateSettings = (name, profilePicture) => {
  return new Promise((resolve, reject) => {
    let user = firebase.auth().currentUser;
    user
      .updateProfile({
        displayName: name,
        photoURL: profilePicture || constants.profile.default_user_image
      })
      .then(() => {
        resolve(user);
      })
      .catch(() => {
        reject(user);
      });
  });
};

export const saveinDatabase = (userId, name, email) => {
  firebase
    .database()
    .ref("users/" + userId)
    .set({
      UserFullName: name,
      Email: email
    });
};
